






























































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import FabricFilter from "@/components/designer/fabric/picker/FabricFilter.vue";
import FabricService from "@/services/fabric_service";
import * as fabric from "@/models/products/fabric";
import { fabricTextureKey } from "@/helpers/fabric";
import Swatch from "@/components/designer/fabric/Swatch.vue";
import { FabricComponent } from "@/models/configurator/fabric_components";
import { mixins } from "vue-class-component";
import { CanopyStore, LayoutStore, ShapeStore } from "@/mixins/store";
import { APIError, NotFoundError } from "@/services/error_service";
import { StockMixin } from "@/mixins/stock";
import { FabricMixin } from "@/mixins/fabric";
import * as option from "@/models/configurator/configurator_options";
import { LayoutRules } from "@/mixins/business_logic/layout/layout_rules";
import { Auth } from "@/mixins/auth";
import { Roles } from "@/models/user/roles";
import FabricComparisonDisclaimer from "@/components/designer/reusable/FabricComparisonDisclaimer.vue";

@Component({
  components: {
    FabricFilter,
    Swatch,
    FabricComparisonDisclaimer
  }
})
export default class FabricSelector extends mixins(
  CanopyStore,
  ShapeStore,
  LayoutStore,
  StockMixin,
  FabricMixin,
  LayoutRules,
  Auth
) {
  @Prop({ default: null }) component!: FabricComponent | null;
  protected selected: fabric.FabricSwatch | null = null;
  protected fabricService = new FabricService();
  protected fabrics: fabric.FabricSwatch[] = [];
  protected searchTerm = "";
  protected fabricComponent = FabricComponent;
  protected solidsOnly = false;
  protected noStripes = false;
  protected filters: fabric.FabricFilter = {
    grade: ["a"],
    color: [],
    design: "",
    brand: "",
    weight: "",
    fabric_type: ""
  };
  protected isCustomFabricWeight = false;
  protected comparisonModalOpen = false;
  protected comparisonFabric: fabric.FabricSwatch | null = null;
  protected unfilteredFabrics: fabric.FabricSwatch[] = [];
  protected availableGrades: Set<string> = new Set();
  protected availableColors: Set<string> = new Set();
  protected availableDesigns: Set<string> = new Set();
  protected availableBrands: Set<string> = new Set();
  protected availableWeights: Set<string> = new Set();

  protected modalTop = "0px";
  protected modalLeft = "0px";
  protected modalWidth = "0px";

  protected ulWidth = "100%";
  protected ulLeft = "0px";

  protected setULDimensions(event: MouseEvent): void {
    const ulElement = (event.currentTarget as HTMLElement).closest("ul");
    const liElement = (event.currentTarget as HTMLElement).closest("li");

    if (ulElement && liElement) {
      const ulRect = ulElement.getBoundingClientRect();
      const liRect = liElement.getBoundingClientRect();

      // Correctly align modal with UL, adjusting for the LI offset
      this.ulWidth = `${ulRect.width}px`;
      this.ulLeft = `${ulRect.left - liRect.left}px`; // Offset LI's left position
    }
  }

  protected openComparisonModal(
    fabric: fabric.FabricSwatch,
    event: MouseEvent
  ): void {
    if (fabric.brand?.mfr?.handle === "recasens") {
      this.select(fabric);
      return;
    }
    const listItem = (event.currentTarget as HTMLElement).closest("li");

    if (listItem) {
      const rect = listItem.getBoundingClientRect();
      const parentRect = listItem.parentElement?.getBoundingClientRect();

      this.modalTop = `${rect.bottom + window.scrollY}px`;
      this.modalLeft = `${
        parentRect ? parentRect.left + window.scrollX : rect.left
      }px`;
      this.modalWidth = `${parentRect ? parentRect.width : rect.width}px`;
    }

    if (this.comparisonFabric?._id === fabric._id) {
      this.comparisonModalOpen = !this.comparisonModalOpen;
      this.comparisonFabric = this.comparisonModalOpen ? fabric : null;
    } else {
      this.comparisonModalOpen = true;
      this.comparisonFabric = fabric;
    }
  }

  protected closeComparisonModal(): void {
    this.comparisonModalOpen = false;
    this.comparisonFabric = null;
  }

  protected toggleComparisonModal(
    fabric: fabric.FabricSwatch,
    event: MouseEvent
  ): void {
    if (this.isFringeComponent || fabric.brand?.mfr?.handle === "recasens") {
      // Prevent showing the modal for recasens swatches
      this.select(fabric);
      this.setULDimensions(event); // Ensure dimensions are updated
      return;
    }
    this.setULDimensions(event); // Ensure dimensions are updated
    this.select(fabric);

    if (this.comparisonFabric?._id === fabric._id) {
      this.comparisonModalOpen = true;
    } else {
      this.comparisonModalOpen = true;
      this.comparisonFabric = fabric;
    }
  }

  /** Switcher that executes logic based on the umbrella component we are selecting a fabric for
   * Watcher on this.component, which changes when user opens fabric selector modal
   */

  @Watch("isStockOnly")
  protected async stockChange(): Promise<void> {
    if (this.isStockOnly) {
      this.allowValance(false);
      this.allowVent(false);
      await this.setGrade("a");
      //EventBus.$emit("changePocket", false);
    } else if (this.component) {
      // Stock turning OFF — rebuild filters from the currently-selected
      // swatch so the user isn't stuck with the grade-A-only constraint
      // when they reopen the picker. The FabricSelector is always mounted
      // (offcanvas, not v-if), so stale state from the prior open persists.
      this.filters = await this.getFilters();
    }
    // Recompute filter availability on every flip so the eligible pool and
    // chip-availability sets reflect the current stock state.
    this.computeAvailableFilters();
  }

  @Watch("noStripes")
  protected onNoStripesChange(): void {
    this.computeAvailableFilters();
  }

  @Watch("component")
  protected async onPropUpdate(): Promise<void> {
    this.showStripes();
    this.solidsOnly = false;
    if (this.component) {
      switch (this.component) {
        case this.fabricComponent.Main:
          this.selected = this.mainFabric[0];
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.MainAlternating:
          this.selected = this.mainFabric[1]
            ? this.mainFabric[1]
            : null;
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.MainAlternatingSecond:
          this.selected = this.mainFabric[2]
            ? this.mainFabric[2]
            : null;
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.MainAlternatingThird:
          this.selected = this.mainFabric[3]
            ? this.mainFabric[3]
            : null;
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.Underside:
          this.selected = this.undersideFabric
            ? this.undersideFabric
            : this.mainFabric[0];
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.TopVent:
          this.selected = this.ventTopFabric[0];
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.MiddleVent:
          this.selected = this.ventMiddleFabric[0];
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.MiddleAlternating:
          this.selected = this.ventMiddleFabric[1]
            ? this.ventMiddleFabric[1]
            : null;
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.MiddleAlternatingSecond:
          this.selected = this.ventMiddleFabric[2]
            ? this.ventMiddleFabric[2]
            : null;
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.MiddleAlternatingThird:
          this.selected = this.ventMiddleFabric[3]
            ? this.ventMiddleFabric[3]
            : null;
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.Binding:
          this.selected = this.bindingFabric;
          this.filters = await this.getFilters();
          break;
        // case this.fabricComponent.Pockets:
        //   this.selected = this.ribFabric;
        //   this.filters = await this.getFilters();
        //   this.noStripes = true;
        //   break;
        case this.fabricComponent.VentTrim:
          this.selected = this.ventTrimFabric
            ? this.ventTrimFabric
            : this.ventTopFabric[1];
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.MainTrim:
          this.selected = this.mainTrimFabric
            ? this.mainTrimFabric
            : this.mainFabric[1];
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.MainTrimInner:
          this.selected = this.mainTrimFabricInner
            ? this.mainTrimFabricInner
            : this.mainFabric[1];
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.Valance:
          this.selected = this.valanceFabric[0];
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.ValanceAlternating:
          this.selected = this.valanceFabric[1]
            ? this.valanceFabric[1]
            : this.valanceFabric[0];
          this.filters = await this.getFilters();
          break;
        case this.fabricComponent.FringeFirst:
        case this.fabricComponent.FringeSecond:
        case this.fabricComponent.FringeThird:
          this.selected = this.fringeFabric[
            this.component === this.fabricComponent.FringeFirst
              ? 0
              : this.component === this.fabricComponent.FringeSecond
              ? 1
              : 2
          ];
          this.filters = await this.getFilters();
          break;
        default:
      }
      this.computeAvailableFilters();
    }
  }

  async mounted(): Promise<void> {
    try {
      // Fetch all fabrics for the unfiltered list
      this.unfilteredFabrics = await this.fabricService.getAllFabrics({
        isAdmin: this.userRole === Roles.Admin,
        isFringe: this.isFringeComponent,
        isBinding: this.isBindingComponent
      });

      // Fetch filtered fabrics for display
      this.fabrics = await this.fabricService.getFabrics({
        grade: this.filters.grade,
        isAdmin: this.userRole === Roles.Admin,
        isFringe: this.isFringeComponent,
        isBinding: this.isBindingComponent
      });
      this.filters = await this.getFilters();
      this.computeAvailableFilters();
    } catch (error) {
      console.error("Error fetching fabrics:", error);
    }
  }

  protected get isFringeComponent(): boolean {
    return (
      this.component === FabricComponent.FringeFirst ||
      this.component === FabricComponent.FringeSecond ||
      this.component === FabricComponent.FringeThird
    );
  }

  /*
   * Unless the user role is Admin, Striped fabrics cannot be selected for any designer layout.
   */
  protected showStripes(): void {
    if (
      this.umbrellaModel!.model.indexOf("-R") > -1 ||
      this.component === this.fabricComponent.VentTrim ||
      this.component === this.fabricComponent.MainTrim ||
      this.component === this.fabricComponent.MainTrimInner ||
      this.component === this.fabricComponent.FringeFirst ||
      this.component === this.fabricComponent.FringeSecond ||
      this.component === this.fabricComponent.FringeThird ||
      (this.userRole !== Roles.Admin &&
        (this.preset === option.Preset.D1 ||
          this.preset === option.Preset.D2 ||
          this.preset === option.Preset.D3 ||
          this.preset === option.Preset.D4 ||
          this.preset === option.Preset.D5))
    ) {
      this.noStripes = true;
    } else {
      this.noStripes = false;
    }
  }

  protected get isMainOrBindingComponent(): boolean {
    if (
      this.component === FabricComponent.Main ||
      this.component === FabricComponent.Binding
    ) {
      return true;
    } else {
      return false;
    }
  }

  protected get isBindingComponent(): boolean {
    return this.component === FabricComponent.Binding;
  }

  /**
   * One-time scrub of `unfilteredFabrics` for the current component context.
   * Builds the permanent disable sets used by FabricFilter — a filter option
   * is disabled when no fabric in the component-eligible pool matches it.
   * Does NOT consider the user's current filter chip selections; filters
   * never disable each other.
   */
  /**
   * Returns the component-eligible fabric pool — `unfilteredFabrics` reduced
   * by component-specific business rules (fringe/binding/underside/etc.).
   * Used by both `computeAvailableFilters` and the default-grade picker so
   * they stay in sync.
   */
  protected getEligiblePool(): fabric.FabricSwatch[] {
    let pool = this.unfilteredFabrics;
    if (this.isStockOnly) {
      pool = pool.filter(f => f.grade === "a");
    }
    if (this.isFringeComponent) {
      pool = pool.filter(f => f.uses?.fringe);
    } else if (this.isBindingComponent) {
      pool = pool.filter(f => f.uses?.binding);
    }
    if (this.isFringeComponent || this.isBindingComponent) {
      pool = pool.filter(f => f.pattern_group?.includes("Solids"));
    }
    if (this.component === this.fabricComponent.Underside) {
      pool = pool.filter(f => f.weight === "8");
    } else if (
      !this.isMainOrBindingComponent &&
      !this.isFringeComponent &&
      this.mainFabric[0]?.weight
    ) {
      // Non-Main/Binding/Fringe components (alternating panels, vents,
      // valances, trims, etc.) must match the primary canopy fabric weight.
      // This is a hard business rule, not a user-toggled filter chip.
      pool = pool.filter(f => f.weight === this.mainFabric[0].weight);
    }
    if (
      this.component === this.fabricComponent.Pockets ||
      this.component === this.fabricComponent.VentTrim ||
      this.component === this.fabricComponent.MainTrim ||
      this.component === this.fabricComponent.MainTrimInner ||
      this.noStripes
    ) {
      pool = pool.filter(
        f => f.pattern_group && !f.pattern_group.includes("Stripes")
      );
    }
    return pool;
  }

  protected computeAvailableFilters(): void {
    const pool = this.getEligiblePool();
    const grades = new Set<string>();
    const colors = new Set<string>();
    const designs = new Set<string>();
    const brands = new Set<string>();
    const weights = new Set<string>();
    for (const f of pool) {
      if (f.grade) grades.add(f.grade);
      if (f.color_group) for (const c of f.color_group) colors.add(c);
      if (f.pattern_group) for (const p of f.pattern_group) designs.add(p);
      if (f.brand?.handle) brands.add(f.brand.handle);
      if (f.weight) weights.add(f.weight);
    }
    this.availableGrades = grades;
    this.availableColors = colors;
    this.availableDesigns = designs;
    this.availableBrands = brands;
    this.availableWeights = weights;
  }

  /**
   * Canonical grade order — used to pick the lowest-grade default that has
   * fabrics remaining in the available pool after business-rule filters apply.
   */
  protected gradeOrder: fabric.FabricGrade[] = [
    "a",
    "ap",
    "b",
    "c",
    "d",
    "e",
    "f",
    "fp"
  ];

  protected firstAvailableGrade(): fabric.FabricGrade | null {
    const pool = this.getEligiblePool();
    for (const grade of this.gradeOrder) {
      if (pool.some(f => f.grade === grade)) return grade;
    }
    return null;
  }

  protected async getFilters(
    fabric?: fabric.FabricSwatch
  ): Promise<fabric.FabricFilter> {
    const swatch = fabric ? fabric : this.selected!;
    const isUnderside = this.component === this.fabricComponent.Underside;
    const undersideDefaultGrade = isUnderside
      ? this.firstAvailableGrade() ?? ("b" as fabric.FabricGrade)
      : null;
    // Pick the default grade, then fall back to the first available grade in
    // the eligible pool if the chosen one has no matching fabrics — otherwise
    // the user lands on a disabled grade chip with "No results."
    const eligiblePool = this.getEligiblePool();
    const isGradeInPool = (g: fabric.FabricGrade): boolean =>
      eligiblePool.some(f => f.grade === g);
    const resolveGrade = (preferred: fabric.FabricGrade): fabric.FabricGrade =>
      isGradeInPool(preferred)
        ? preferred
        : this.firstAvailableGrade() ?? preferred;
    const filters = {
      grade:
        this.isFringeComponent || this.isBindingComponent
          ? []
          : isUnderside
          ? [undersideDefaultGrade as fabric.FabricGrade]
          : swatch && swatch.grade
          ? [resolveGrade(swatch.grade)]
          : this.filters.grade.length > 1
          ? this.filters.grade
          : [resolveGrade("a" as fabric.FabricGrade)],
      color: [],
      design: this.solidsOnly ? "Solids" : "",
      brand: "",
      weight: this.isMainOrBindingComponent || this.isFringeComponent
        ? ""
        : isUnderside
        ? "8"
        : this.mainFabric[0].weight!,
      fabric_type: ""
    } as fabric.FabricFilter;
    await this.setGrade(
      this.isFringeComponent || this.isBindingComponent
        ? null
        : filters.grade[0]
    );
    return filters;
  }

  protected async getFabrics(): Promise<fabric.FabricSwatch[]> {
    const loader = this.$loading.show({
      isFullPage: false,
      container: this.$refs.spinnerContainerFabric
    });
    let fabricArray: fabric.FabricSwatch[] = [];
    try {
      // Fetch filtered fabrics for display
      const res = await this.fabricService.getFabrics({
        grade: this.filters.grade ? this.filters.grade : undefined,
        isAdmin: this.userRole === Roles.Admin,
        isFringe: this.isFringeComponent,
        isBinding: this.isBindingComponent
      });

      fabricArray = res;
      this.$nextTick(() => {
        loader.hide();
      });
    } catch (err) {
      if (err instanceof NotFoundError) {
        NotFoundError.popup(err.message, err.statusCode);
      } else {
        APIError.popup(err.message, err.statusCode);
      }
      loader.hide();
    }
    return fabricArray;
  }

  protected getFabricByCode(code: string): fabric.FabricSwatch | undefined {
    const normalized = code.trim().toLowerCase();
    return this.fabrics.find(
      fabric =>
        fabric.mfr_code === code ||
        fabric.alt_mfr_code === code ||
        fabric.mfr_code.toLowerCase() === normalized ||
        (fabric.alt_mfr_code && fabric.alt_mfr_code.toLowerCase() === normalized)
    );
  }
  /**
   * Resolve the `comparisons` array on a fabric into full FabricSwatch objects
   * from `unfilteredFabrics`. The array may contain either ObjectId strings
   * (backend-serialized refs) or populated FabricSwatch objects; both are
   * supported.
   */
  protected getComparisonSwatches(
    comparisons:
      | fabric.FabricSwatch[]
      | string[]
      | undefined
  ): fabric.FabricSwatch[] {
    if (!comparisons || comparisons.length === 0) return [];

    return comparisons
      .map((entry: any) => {
        // Populated object: return as-is
        if (entry && typeof entry === "object" && entry._id) {
          return entry as fabric.FabricSwatch;
        }
        // ObjectId string: find by _id in unfilteredFabrics
        if (typeof entry === "string") {
          return this.unfilteredFabrics.find(f => f._id === entry);
        }
        return undefined;
      })
      .filter(Boolean) as fabric.FabricSwatch[];
  }

  /** Getter for filtering fabrics with logic to account for all different available filters */
  protected get filteredFabrics(): fabric.FabricSwatch[] {
    let fabricArray: fabric.FabricSwatch[] = this.searchTerm
      ? [...this.getEligiblePool()]
      : [...this.fabrics];
    fabricArray = fabricArray.filter(swatch => swatch.image); // Only show fabrics with images in the selector
    if (
      this.component === FabricComponent.Pockets ||
      this.component === this.fabricComponent.VentTrim ||
      this.component === this.fabricComponent.MainTrim ||
      this.component === this.fabricComponent.MainTrimInner
    ) {
      fabricArray = fabricArray.filter(swatch => {
        const pattern: fabric.FabricSwatch["pattern_group"] = swatch.pattern_group!;
        if (pattern.length > 0) {
          return !pattern.includes("Stripes");
        } else {
          return false;
        }
      });
    }
    if (this.searchTerm) {
      const term = this.searchTerm
        .toLowerCase()
        .trim()
        .replace(/[-/]/g, ""); // examines the search term regardless of hyphens or slashes (e.g. "5615" matches "5/615")
      const matches = fabricArray.filter(swatch => {
        return (
          swatch.mfr_code
            .toLowerCase()
            .replace(/[-/]/g, "")
            .indexOf(term) !== -1
        );
      });
      const matchesAltCode = fabricArray.filter(swatch => {
        if (swatch.alt_mfr_code) {
          return (
            swatch.alt_mfr_code
              .toLowerCase()
              .replace(/[-/]/g, "")
              .indexOf(term) !== -1
          );
        }
        return false;
      });
      const matchesName = fabricArray.filter(swatch => {
        const displayName = swatch.name?.display?.toLowerCase() ?? "";
        return displayName.indexOf(term) !== -1;
      });
      const matchesFFcode = fabricArray.filter(swatch => {
        if (swatch.frankford_code) {
          return (
            swatch.frankford_code
              .toLowerCase()
              .replace(/[-/]/g, "")
              .indexOf(term) !== -1
          );
        }
        return false;
      });
      // de-duplicate across match categories (same swatch may match multiple)
      const merged: fabric.FabricSwatch[] = [];
      const seen = new Set<string>();
      for (const swatch of [...matches, ...matchesAltCode, ...matchesName, ...matchesFFcode]) {
        if (!seen.has(swatch._id)) {
          seen.add(swatch._id);
          merged.push(swatch);
        }
      }
      fabricArray = merged;
      return fabricArray;
    }
    if (this.filters.brand) {
      fabricArray = fabricArray.filter(swatch => {
        return swatch.brand?.handle === this.filters.brand;
      });
    }
    if (this.filters.design) {
      fabricArray = fabricArray.filter(swatch => {
        const pattern: fabric.FabricSwatch["pattern_group"] = swatch.pattern_group!;
        if (pattern.length > 0) {
          return pattern.includes(this.filters.design);
        } else {
          return false;
        }
      });
    }
    if (this.filters.color.length > 0) {
      const matches: fabric.FabricSwatch[] = [];
      fabricArray.map(swatch => {
        const colors: fabric.FabricSwatch["color_group"] = swatch.color_group!;
        if (colors.length > 0) {
          colors.map(color => {
            if (this.filters.color.includes(color)) {
              matches.push(swatch);
            }
          });
        }
      });
      fabricArray = matches;
    }
    if (this.noStripes) {
      fabricArray = fabricArray.filter(swatch => {
        const pattern: fabric.FabricSwatch["pattern_group"] = swatch.pattern_group!;
        if (pattern.length > 0 && pattern.includes("Stripes")) {
          return false;
        } else {
          return true;
        }
      });
    }
    if (this.filters.weight) {
      fabricArray = fabricArray.filter(swatch => {
        return swatch.weight === this.filters.weight;
      });
    }
    if (this.filters.fabric_type) {
      fabricArray = fabricArray.filter(swatch => {
        return swatch.fabric_type === this.filters.fabric_type;
      });
    }
    if (this.isBindingComponent || this.isFringeComponent) {
      const whpIdx = fabricArray.findIndex(
        swatch => swatch.mfr_code === "WHP"
      );
      if (whpIdx > 0) {
        const [whp] = fabricArray.splice(whpIdx, 1);
        fabricArray.unshift(whp);
      }
    }
    return fabricArray;
  }

  /** Switcher that communicates with umbrella modeler & saves choice to store based on user selections and specific umbrella component */
  protected async select(swatch: fabric.FabricSwatch): Promise<void> {
    console.log("Fabric selection initiated:", {
      component: this.component,
      fabric: {
        code: swatch.mfr_code,
        alt_code: swatch.alt_mfr_code,
        name: swatch.name?.display,
        grade: swatch.grade,
        mfr: swatch.brand?.mfr?.name
      },
      comparisons: swatch.comparisons
    });

    if (!this.component) return;
    this.selected = swatch; // Ensure the selected swatch is updated globally
    switch (this.component) {
      case this.fabricComponent.Main:
        // ToDo: FUMBSD-653 -- QA! - Four Panels. Update logic to no longer lose any possibly pre-selected panels for AlternatingSecond and AlternatingThird fabrics.
        // write standalone method to handle this logic for main canopy only. expand into stand alone function for double vent and valances thereafter.
        if (this.mainFabric[1]) {
          // only analyze the weight difference of the second array element since the weight is initially set by the first element in the array.
          const isEqualWeight = this.mainFabric[1].weight === swatch.weight;
          if (isEqualWeight) {
            // only replace the first element in the array with the new swatch if the weights are equal. Keep the remaining elements as is.
            const mainFabricCopy = [
              ...this.mainFabric
            ] as fabric.FabricSwatch[];
            mainFabricCopy[0] = swatch;
            await this.addMainFabric(
              (mainFabricCopy as unknown) as fabric.FixedFabricArray
            );
            // await this.addMainFabric([swatch, this.mainFabric[1]]);
          } else {
            // replace the entire array with the selected swatch, applicable for the length of the mainFabric array.
            await this.addMainFabric(
              (this.mainFabric.map(
                () => swatch
              ) as unknown) as fabric.FixedFabricArray
            );
            // await this.addMainFabric([swatch, swatch]);
          }
        } else {
          // only one fabric selected, so just add it.
          await this.addMainFabric([swatch]);
        }
        await this.applyLayoutRules();
        this.selected = swatch;
        // change viewer
        await this.$viewer.ChangeCanopyFabric(
          swatch.fabric_scale,
          fabricTextureKey(swatch),
          this.mainFabric[1] ? this.mainFabric[1].fabric_scale : undefined,
          this.mainFabric[1] ? fabricTextureKey(this.mainFabric[1]) : undefined,
          this.mainFabric[2] ? this.mainFabric[2].fabric_scale : undefined,
          this.mainFabric[2] ? fabricTextureKey(this.mainFabric[2]) : undefined,
          this.mainFabric[3] ? this.mainFabric[3].fabric_scale : undefined,
          this.mainFabric[3] ? fabricTextureKey(this.mainFabric[3]) : undefined
        );

        if (this.rib === option.Rib.Pockets) {
          await this.addRibFabric(swatch);
          this.$viewer.ChangeRibAttachment(this.rib, fabricTextureKey(swatch));
        }
        break;
      case this.fabricComponent.MainAlternating: {
        // only replace the second element in the array with the new swatch if the weights are equal. Keep the remaining elements as is.
        const mainFabricCopy = [...this.mainFabric] as fabric.FabricSwatch[];
        mainFabricCopy[1] = swatch;
        await this.addMainFabric(
          (mainFabricCopy as unknown) as fabric.FixedFabricArray
        );
        // await this.addMainFabric([this.mainFabric[0], swatch]);
        await this.applyLayoutRules();
        this.selected = swatch;
        await this.$viewer.ChangeCanopyFabric(
          this.mainFabric[0].fabric_scale,
          fabricTextureKey(this.mainFabric[0]),
          swatch.fabric_scale,
          fabricTextureKey(swatch),
          this.mainFabric[2] ? this.mainFabric[2].fabric_scale : undefined,
          this.mainFabric[2] ? fabricTextureKey(this.mainFabric[2]) : undefined,
          this.mainFabric[3] ? this.mainFabric[3].fabric_scale : undefined,
          this.mainFabric[3] ? fabricTextureKey(this.mainFabric[3]) : undefined
        );
        break;
      }
      case this.fabricComponent.MainAlternatingSecond: {
        const mainFabricCopy = [...this.mainFabric] as fabric.FabricSwatch[];
        mainFabricCopy[2] = swatch;
        await this.addMainFabric(
          (mainFabricCopy as unknown) as fabric.FixedFabricArray
        );
        await this.applyLayoutRules();
        this.selected = swatch;
        await this.$viewer.ChangeCanopyFabric(
          this.mainFabric[0].fabric_scale,
          fabricTextureKey(this.mainFabric[0]),
          this.mainFabric[1].fabric_scale,
          fabricTextureKey(this.mainFabric[1]),
          swatch.fabric_scale,
          fabricTextureKey(swatch),
          this.mainFabric[3] ? this.mainFabric[3].fabric_scale : this.mainFabric[1].fabric_scale,
          this.mainFabric[3] ? fabricTextureKey(this.mainFabric[3]) : fabricTextureKey(this.mainFabric[1])
        );
        break;
      }
      case this.fabricComponent.MainAlternatingThird: {
        // only replace the fourth element in the array with the new swatch if the weights are equal. Keep the remaining elements as is.
        await this.addMainFabric([
          this.mainFabric[0],
          this.mainFabric[1],
          this.mainFabric[2],
          swatch
        ]);
        await this.applyLayoutRules();
        this.selected = swatch;
        await this.$viewer.ChangeCanopyFabric(
          this.mainFabric[0].fabric_scale,
          fabricTextureKey(this.mainFabric[0]),
          this.mainFabric[1].fabric_scale,
          fabricTextureKey(this.mainFabric[1]),
          this.mainFabric[2].fabric_scale,
          fabricTextureKey(this.mainFabric[2]),
          swatch.fabric_scale,
          fabricTextureKey(swatch)
        );
        break;
      }
      case this.fabricComponent.TopVent:
        this.allowVent(true);
        await this.addVentTopFabric([swatch]);
        await this.applyLayoutRules();
        this.selected = swatch;
        await this.$viewer.ChangeTopVentFabric(
          swatch.fabric_scale,
          fabricTextureKey(swatch)
        );
        break;
      case this.fabricComponent.MiddleVent: {
        this.allowVent(true);
        const ventMiddleFabricCopy = [
          ...this.ventMiddleFabric
        ] as fabric.FabricSwatch[];
        ventMiddleFabricCopy[0] = swatch;
        await this.addVentMiddleFabric(
          (ventMiddleFabricCopy as unknown) as fabric.FixedFabricArray
        );
        // await this.addVentMiddleFabric([swatch, this.ventMiddleFabric[1]]);
        await this.applyLayoutRules();
        this.selected = swatch;
        await this.$viewer.ChangeDblVentFabric(
          swatch.fabric_scale,
          fabricTextureKey(swatch),
          this.ventMiddleFabric[1] ? this.ventMiddleFabric[1].fabric_scale : undefined,
          this.ventMiddleFabric[1] ? fabricTextureKey(this.ventMiddleFabric[1]) : undefined,
          this.ventMiddleFabric[2] ? this.ventMiddleFabric[2].fabric_scale : undefined,
          this.ventMiddleFabric[2] ? fabricTextureKey(this.ventMiddleFabric[2]) : undefined,
          this.ventMiddleFabric[3] ? this.ventMiddleFabric[3].fabric_scale : undefined,
          this.ventMiddleFabric[3] ? fabricTextureKey(this.ventMiddleFabric[3]) : undefined
        );
        break;
      }
      case this.fabricComponent.MiddleAlternating: {
        this.allowVent(true);
        const ventMiddleFabricCopy = [
          ...this.ventMiddleFabric
        ] as fabric.FabricSwatch[];
        ventMiddleFabricCopy[1] = swatch;
        await this.addVentMiddleFabric(
          (ventMiddleFabricCopy as unknown) as fabric.FixedFabricArray
        );
        // await this.addVentMiddleFabric([this.ventMiddleFabric[0], swatch]);
        await this.applyLayoutRules();
        this.selected = swatch;
        await this.$viewer.ChangeDblVentFabric(
          this.ventMiddleFabric[0].fabric_scale,
          fabricTextureKey(this.ventMiddleFabric[0]),
          swatch.fabric_scale,
          fabricTextureKey(swatch),
          this.ventMiddleFabric[2] ? this.ventMiddleFabric[2].fabric_scale : undefined,
          this.ventMiddleFabric[2] ? fabricTextureKey(this.ventMiddleFabric[2]) : undefined,
          this.ventMiddleFabric[3] ? this.ventMiddleFabric[3].fabric_scale : undefined,
          this.ventMiddleFabric[3] ? fabricTextureKey(this.ventMiddleFabric[3]) : undefined
        );
        break;
      }
      case this.fabricComponent.MiddleAlternatingSecond: {
        this.allowVent(true);
        const ventMiddleFabricCopy = [
          ...this.ventMiddleFabric
        ] as fabric.FabricSwatch[];
        ventMiddleFabricCopy[2] = swatch;
        await this.addVentMiddleFabric(
          (ventMiddleFabricCopy as unknown) as fabric.FixedFabricArray
        );
        await this.applyLayoutRules();
        this.selected = swatch;
        await this.$viewer.ChangeDblVentFabric(
          this.ventMiddleFabric[0].fabric_scale,
          fabricTextureKey(this.ventMiddleFabric[0]),
          this.ventMiddleFabric[1].fabric_scale,
          fabricTextureKey(this.ventMiddleFabric[1]),
          swatch.fabric_scale,
          fabricTextureKey(swatch),
          this.ventMiddleFabric[3] ? this.ventMiddleFabric[3].fabric_scale : this.ventMiddleFabric[1].fabric_scale,
          this.ventMiddleFabric[3] ? fabricTextureKey(this.ventMiddleFabric[3]) : fabricTextureKey(this.ventMiddleFabric[1])
        );
        break;
      }
      case this.fabricComponent.MiddleAlternatingThird: {
        this.allowVent(true);
        await this.addVentMiddleFabric([this.ventMiddleFabric[0], this.ventMiddleFabric[1], this.ventMiddleFabric[2], swatch]);
        await this.applyLayoutRules();
        this.selected = swatch;
        await this.$viewer.ChangeDblVentFabric(
          this.ventMiddleFabric[0].fabric_scale,
          fabricTextureKey(this.ventMiddleFabric[0]),
          this.ventMiddleFabric[1].fabric_scale,
          fabricTextureKey(this.ventMiddleFabric[1]),
          this.ventMiddleFabric[2].fabric_scale,
          fabricTextureKey(this.ventMiddleFabric[2]),
          swatch.fabric_scale,
          fabricTextureKey(swatch)
        );
        break;
      }
      case this.fabricComponent.Underside:
        await this.addUndersideFabric(swatch);
        this.selected = swatch;
        await this.$viewer.ChangeUndersideFabric(fabricTextureKey(swatch), swatch.fabric_scale);
        break;
      case this.fabricComponent.Binding:
        await this.addBindingFabric(swatch);
        this.selected = swatch;
        this.hasValanceBindingOverride = true;
        await this.$viewer.ChangeBindingFabric(fabricTextureKey(swatch));
        break;
      // case this.fabricComponent.Pockets:
      //   await this.addRibFabric(swatch);
      //   this.selected = swatch;
      //   await this.$viewer.ChangeRibAttachment(this.rib, swatch.mfr_code);
      //   EventBus.$emit("changePocket", true);
      //   break;
      case this.fabricComponent.MainTrim:
        await this.addMainTrimFabric(swatch);
        this.selected = swatch;
        await this.$viewer.ChangeCanopyTrim(
          fabricTextureKey(swatch),
          this.mainTrimFabricInner ? fabricTextureKey(this.mainTrimFabricInner) : null
        );
        break;
      case this.fabricComponent.MainTrimInner:
        await this.addMainTrimFabricInner(swatch);
        this.selected = swatch;
        await this.$viewer.ChangeCanopyTrim(
          fabricTextureKey(this.mainTrimFabric!),
          fabricTextureKey(swatch)
        );
        break;
      case this.fabricComponent.VentTrim:
        await this.addVentTrimFabric(swatch);
        this.selected = swatch;
        await this.$viewer.ChangeVentTrim(fabricTextureKey(swatch));
        break;
      case this.fabricComponent.Valance: {
        const valanceFabricCopy = [
          ...this.valanceFabric
        ] as fabric.FabricSwatch[];
        valanceFabricCopy[0] = swatch;
        await this.addValanceFabric(
          (valanceFabricCopy as unknown) as fabric.FixedFabricArray
        );
        this.selected = swatch;
        this.allowValance(true);
        await this.$viewer.ChangeValanceFabric(
          swatch.fabric_scale,
          fabricTextureKey(swatch),
          this.valanceFabric[1] ? this.valanceFabric[1].fabric_scale : undefined,
          this.valanceFabric[1] ? fabricTextureKey(this.valanceFabric[1]) : undefined,
          this.valanceFabric[2] ? this.valanceFabric[2].fabric_scale : undefined,
          this.valanceFabric[2] ? fabricTextureKey(this.valanceFabric[2]) : undefined,
          this.valanceFabric[3] ? this.valanceFabric[3].fabric_scale : undefined,
          this.valanceFabric[3] ? fabricTextureKey(this.valanceFabric[3]) : undefined
        );
        break;
      }
      case this.fabricComponent.ValanceAlternating: {
        const valanceFabricCopy = [
          ...this.valanceFabric
        ] as fabric.FabricSwatch[];
        valanceFabricCopy[1] = swatch;
        await this.addValanceFabric(
          (valanceFabricCopy as unknown) as fabric.FixedFabricArray
        );
        this.selected = swatch;
        this.allowValance(true);
        await this.$viewer.ChangeValanceFabric(
          this.valanceFabric[0].fabric_scale,
          fabricTextureKey(this.valanceFabric[0]),
          swatch.fabric_scale,
          fabricTextureKey(swatch),
          this.valanceFabric[2] ? this.valanceFabric[2].fabric_scale : undefined,
          this.valanceFabric[2] ? fabricTextureKey(this.valanceFabric[2]) : undefined,
          this.valanceFabric[3] ? this.valanceFabric[3].fabric_scale : undefined,
          this.valanceFabric[3] ? fabricTextureKey(this.valanceFabric[3]) : undefined
        );
        break;
      }
      case this.fabricComponent.ValanceAlternatingSecond: {
        const valanceFabricCopy = [
          ...this.valanceFabric
        ] as fabric.FabricSwatch[];
        valanceFabricCopy[2] = swatch;
        await this.addValanceFabric(
          (valanceFabricCopy as unknown) as fabric.FixedFabricArray
        );
        this.selected = swatch;
        this.allowValance(true);
        await this.$viewer.ChangeValanceFabric(
          this.valanceFabric[0].fabric_scale,
          fabricTextureKey(this.valanceFabric[0]),
          this.valanceFabric[1].fabric_scale,
          fabricTextureKey(this.valanceFabric[1]),
          swatch.fabric_scale,
          fabricTextureKey(swatch),
          this.valanceFabric[3] ? this.valanceFabric[3].fabric_scale : this.valanceFabric[1].fabric_scale,
          this.valanceFabric[3] ? fabricTextureKey(this.valanceFabric[3]) : fabricTextureKey(this.valanceFabric[1])
        );
        break;
      }
      case this.fabricComponent.ValanceAlternatingThird: {
        await this.addValanceFabric([
          this.valanceFabric[0],
          this.valanceFabric[1],
          this.valanceFabric[2],
          swatch
        ]);
        this.selected = swatch;
        this.allowValance(true);
        await this.$viewer.ChangeValanceFabric(
          this.valanceFabric[0].fabric_scale,
          fabricTextureKey(this.valanceFabric[0]),
          this.valanceFabric[1].fabric_scale,
          fabricTextureKey(this.valanceFabric[1]),
          this.valanceFabric[2].fabric_scale,
          fabricTextureKey(this.valanceFabric[2]),
          swatch.fabric_scale,
          fabricTextureKey(swatch)
        );
        break;
      }
      case this.fabricComponent.FringeFirst:
        this.selected = swatch;
        await this.addFringeFabric(
          this.fringeFabric[0]
            ? (this.fringeFabric as any).toSpliced(0, 1, swatch)
            : [swatch]
        );
        await this.changeViewerFringe();
        if (!this.hasValanceBindingOverride) {
          await this.addBindingFabric(this.fringeFabric[0]);
          await this.$viewer.ChangeBindingFabric(fabricTextureKey(this.fringeFabric[0]));
        }
        console.log("Fringe fabric (first) selected:", swatch.mfr_code);
        break;
      case this.fabricComponent.FringeSecond:
        this.selected = swatch;
        await this.addFringeFabric(
          (this.fringeFabric as any).toSpliced(1, 1, swatch)
        );
        await this.changeViewerFringe();
        console.log("Fringe fabric (second) selected:", swatch.mfr_code);
        break;
      case this.fabricComponent.FringeThird:
        this.selected = swatch;
        await this.addFringeFabric(
          (this.fringeFabric as any).toSpliced(2, 1, swatch)
        );
        await this.changeViewerFringe();
        console.log("Fringe fabric (third) selected:", swatch.mfr_code);
    }
  }

  protected async changeViewerFringe(): Promise<void> {
    await this.$viewer.ChangeFringe(
      this.fringe,
      this.fringeFabric[0] ? fabricTextureKey(this.fringeFabric[0]) : undefined,
      this.fringeFabric[1] ? fabricTextureKey(this.fringeFabric[1]) : undefined,
      this.fringeFabric[2] ? fabricTextureKey(this.fringeFabric[2]) : undefined
    );
  }

  /** set####() methods below set filter values communicated from child FabricFilter.vue */
  protected async setGrade(value: fabric.FabricGrade | null): Promise<void> {
    if (value === "a/ap") {
      this.filters.grade = ["a", "ap"];
    } else if (!value) {
      this.filters.grade = [];
    } else {
      this.filters.grade = [value];
    }
    this.fabrics = await this.getFabrics();
  }

  protected setColor(values: string[] | []): void {
    this.filters.color = values;
  }

  protected setDesign(value: string): void {
    this.filters.design = value;
  }

  protected setBrand(value: string): void {
    this.filters.brand = value;
  }

  /**
   * Removes the default weight selection of "all" fabrics
   * once a fabric has been manually selected by the user.
   */
  protected setCustomWeight(): void {
    this.isCustomFabricWeight = true;
  }

  protected setWeight(value: string, hasCustomWeight = false): void {
    this.filters.weight = value;
    this.isCustomFabricWeight = hasCustomWeight ? true : false;
  }

  protected setFabricType(value: string): void {
    this.filters.fabric_type = value;
  }
}
